<template>
	<div class="flex flex-col">
		<div v-for="log in visibleLogs" :key="log.id" class="flex gap-5 py-2 flex-row items-center odd:bg-white even:bg-sky-50 px-5">
			<div class="flex flex-col flex-grow break-all">
				<div class="w-full flex font-medium flex-col">
					<Link v-if="log.targetable?.name" :href="route('structures.get', { structure: log.targetable_id })" class="cursor-pointer">
						{{ log.targetable.name }}
					</Link>
					<Link v-if="log.targetable?.first_name" :href="route('contacts.get', { contact: log.targetable_id })" class="cursor-pointer">
						{{ log.targetable.first_name }} {{ log.targetable.last_name }}
						<span v-if="log.targetable.targeted" class="rounded text-blue-500 p-1">
							<i class="fas fa-crosshairs"></i>
						</span>
					</Link>
					<p v-if="log.status?.name" class="text-sm text-gray-400">
						{{ log.status.name }}
					</p>
					<div>
						<log-comment v-if="log.comment" class="text-gray-500 text-sm" :log="log" />
					</div>
				</div>
			</div>
			<div class="flex flex-col items-center text-xs">
				<div :title="$d.fromISO(log.date_at).toLocaleString($d.DATETIME_SHORT)" class="text-right flex-nowrap whitespace-nowrap">
					{{ $d.fromISO(log.date_at).toRelative({ style: 'short' }) }}
				</div>
				<div class="text-gray-400 text-center">
					<p>{{ log?.user?.first_name.charAt(0) }}. {{ log?.user?.last_name }}</p>
				</div>
			</div>
		</div>
		<ui-button @click="loadMore" v-if="displayCount < logs.length">
			<template v-slot:text>Plus d'évènements</template>
		</ui-button>
	</div>
</template>

<script setup>
	import { Link } from '@inertiajs/vue3';
	import { ref, computed } from 'vue';

	const props = defineProps({
		logs: {
			type: Object,
			required: true,
			default: () => [],
		},
	});

	const LogsDisplay = 5;
	const displayCount = ref(LogsDisplay);

	const visibleLogs = computed(() => {
		return props.logs.slice(0, displayCount.value);
	});

	const loadMore = () => {
		displayCount.value += LogsDisplay;
	};
</script>
